import { FaQuestionCircle } from "react-icons/fa";
import styled from "styled-components";

export const RadioContainer = styled.div`
  margin-top: 24px;

  input {
    accent-color: ${({ theme }) => theme.colors.project.main};
    margin-right: 1rem;
    width: 1rem;
    height: 1rem;
  }
`;

export const OptionContainer = styled.span`
  margin-right: 24px;
`;

export const IconeTooltipServico = styled(FaQuestionCircle)`
  color: ${({ theme }) => theme.colors.project.main};
  margin-left: 10px;
`;

export const InputContainer = styled.div`
  margin-top: 24px;
`;

export const ContainerFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;